import { Col, Row } from 'antd';
import styled from 'styled-components';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';

export const Container = styled(Row)`
  margin: 12px;
`;

export const MapCol = styled(Col)`
  height: calc(100vh - 170px);
  ${cssMediaBreakpoints.mobileOrTablet} {
    height: auto;
  }
`;
